import React, { useState, useEffect } from "react";
import "../../Style.css";
import "../../Responsive.css";
import "../../bootstrap.min.css";
import { Box, Container, Stack } from "@mui/system";
import Utils from "../../core/Utils";
import UserHelper from "../../core/UserHelper";
import { LoginPage, OrderDetailsPage, OrderSummaryPage, PurchaseOrderPage } from "../../core/PageConstants";
import { useNavigate } from "react-router-dom";
import { Button, Card, Divider, Grid, Tab, Tabs, Typography } from "@mui/material";
import Loader from "../common/Loader";
import MessagePopup from "../common/MessagePopUp";
import SideBarMenuItems from "../SideBarMenuItems";
import { MaxDateLimit, SideBarMenuNames } from "../../core/Constants";
import { OverviewPage } from "../../core/PageConstants";
import "../../DateRangePickerWithYear.css";
import "react-calendar/dist/Calendar.css";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { useDispatch } from "react-redux";
import { getCountry } from "../../data/localSettingsActions";
import { connectToStore } from "../../data/store";
import { postAsync } from "../../core/serviceClient";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import CountryHelper from "../../core/CountryHelper";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import moment from "moment";
import VendorSelectionDialog from "../dialogs/VendorSelectionDialog";

const BelowThreshold = () => {
    document.title = "Order Details";
    var pageTitle = "Order Details";
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [msgOpen, setMsgOpen] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isNavigateToLogin, setIsNavigateToLogin] = useState(false);
    const [vendorList, setVendorList] = useState([]);
    const [localSettings, setLocalSettings] = useState({});
    const [selectedVendor, setSelectedVendor] = React.useState("");
    const [selectedDate, setSelectedDate] = useState([
        Utils.GetStartDate(),
        Utils.GetEndDate(),
    ]);
    const [orderList, setOrderList] = React.useState([]);
    const [countryInfo, setCountryInfo] = useState({});
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [isVendorDialogOpen, setIsVendorDialogOpen] = useState(false);

    useEffect(() => {
        let localSetting = connectToStore();
        if (UserHelper.CheckPermission(OrderDetailsPage, navigate)) {
            setLocalSettings(localSetting);
            setCountryInfo(getCountry());
            getOrderDetails(selectedDate[0], selectedDate[1]);
        }
    }, []);

    const getOrderDetails = async (startDT, endDT) => {
        setIsLoading(true);
        let localSetting = connectToStore();
        let response = null;
        response = await postAsync("PurchaseOrder/GetAllPurchaseOrder", {
            Start: Utils.GetISODateTimeString(startDT),
            End: Utils.GetISODateTimeString(endDT),
            BusinessId: localSetting.business.businessId,
            BranchId: localSetting.branch.branchId,
        });
        setIsNavigateToLogin(response.isNavigateToLogin);
        if (response.error) {
            setMsgOpen(true);
            setMsgText(response.errorMessage);
        } else {
            setOrderList(response.data);
        }
        setIsLoading(false);
    }
    useEffect(() => {
        getVendorDetails();
    }, [localSettings]);

    const getVendorDetails = async () => {
        if (localSettings.authenticated) {
            setIsLoading(true);
            let result = await postAsync(
                "Vendor/GetVendorDetails",
                {},
                "",
                "GetAll",
                "GetAllVendorDetailsByBusiness",
                [localSettings.business.id]
            );
            setIsNavigateToLogin(result.isNavigateToLogin);
            if (result.error) {
                setMsgOpen(true);
                setMsgText(result.errorMessage);
            } else {
                if (!Utils.IsNullOrEmptyArray(result.data)) {
                    setVendorList(
                        (result?.data || []).filter(v => v.vendorStatus === true)
                    );
                }
            }
            setIsLoading(false);
        }
    };
    const handleMsgClose = () => {
        setMsgOpen(false);
        if (isNavigateToLogin) {
            UserHelper.LogOut(dispatch);
            navigate(LoginPage.Path);
        }
    };
    const backNavigation = () => {
        navigate(OverviewPage.Path, {});
    };

    const onDateChange = (date) => {
        if (!Utils.IsNullOrEmptyArray(date)) {
            var dateArray = [moment(date[0]), moment(date[1])];
            if (dateArray[0]._isValid == false || dateArray[1]._isValid == false) {
                setMsgText(
                    "Please select a valid date range."
                );
                setMsgOpen(true);
            }
            else {
                let dateDiff = dateArray[1].diff(dateArray[0], "days");
                if (dateDiff > MaxDateLimit) {
                    setMsgText(
                        "Please note that the maximum date range you can select is 90 days. You can choose any start date within the past 90 days, but the end date cannot exceed this limit."
                    );

                    setMsgOpen(true);
                } else {
                    setSelectedDate(dateArray);
                    getOrderDetails(dateArray[0], dateArray[1]);
                }
            }
        }
    };
    const [tabIndex, setTabIndex] = useState(0);
    const handleChange = (event, newValue) => setTabIndex(newValue);
    const getOrdersByStatus = (status) =>
        orderList
            .filter(o => o.status === status)
            .sort((a, b) => new Date(b.createdDT) - new Date(a.createdDT));


    const requestedOrders = getOrdersByStatus("Requested");
    const partiallyShippedOrders = getOrdersByStatus("PartiallyShipped");
    const receivedOrders = getOrdersByStatus("Received");
    const rejectedOrders = getOrdersByStatus("Rejected");

    const getFilteredOrders = () => {
        switch (tabIndex) {
            case 0: return requestedOrders;
            case 1: return partiallyShippedOrders;
            case 2: return receivedOrders;
            case 3: return rejectedOrders;
            default: return [];
        }
    };





    const handleOpenDialog = () => setIsDialogOpen(true);
    const handleCloseDialog = () => setIsDialogOpen(false);

    const handleCreateOrder = () => {
        setIsVendorDialogOpen(true);
    }
    const NavigationPurchaseOrder = () => {
        navigate(PurchaseOrderPage.Path, {
            state: {
                SelectedVendor: selectedVendor,
                isCreateNewOrder: true,
            }
        });
    }
    const handleVendorCloseDialog = () => {
        setIsVendorDialogOpen(false);
    }



    const handlenavigateOrderDetails = (order) => {
        navigate(OrderSummaryPage.Path, {
            state: {
                order: order
            }
        })
    };


    function getVendorFullAddress(vendor) {
        if (!vendor) return '';

        if (Utils.IsNullOrEmpty(vendor.vendorAddress)) {
            const parts = [
                vendor.vendorCustomAddress,
                vendor.vendorCustomCity,
                vendor.vendorCustomState,
                vendor.vendorCustomPinCode
            ].filter(Boolean);

            return parts.join(', ');
        }

        return vendor.vendorAddress;
    }
    return (
        <Container maxWidth="false" className="bg-color p-0">
            <Grid className="container">
                <Loader open={isLoading} />
                <MessagePopup
                    msgOpen={msgOpen}
                    msgText={msgText}
                    onMsgClose={handleMsgClose}
                />


                <VendorSelectionDialog
                    open={isVendorDialogOpen}
                    onClose={handleVendorCloseDialog}
                    vendorList={vendorList}
                    selectedVendor={selectedVendor}
                    setSelectedVendor={setSelectedVendor}
                    onSubmit={NavigationPurchaseOrder}
                />
                <Box>
                    <Grid container m={0}>
                        <SideBarMenuItems selectedTab={SideBarMenuNames.Overview} />
                        <Grid xs={12} className="content-sec" sx={{ "padding-bottom": "100px" }}>
                            <Grid container direction="row" className="">
                                <Grid container className="title-sec">
                                    <Grid xs={12} md={8} lg={8}>
                                        <Typography
                                            level="h2"
                                            component="h2"
                                            fontWeight="600"
                                            fontSize="2rem"
                                        >
                                            <Button onClick={backNavigation} className="back-btn">
                                                <NavigateBeforeIcon />
                                            </Button>
                                            Order Details
                                        </Typography>
                                    </Grid>
                                    <Grid
                                        container
                                        xs={12}
                                        md={4}
                                        lg={4}
                                        className="form-inline text-right bt-xs-1 date-picker-sec fixed-xs-btn"
                                        style={{
                                            "align-self": "center",
                                            "justify-content": "end",
                                        }}
                                    >
                                        <Stack
                                            direction="row"
                                            justifyContent="end"
                                            style={{ height: "100%", padding: "0 10px" }}
                                            className="btn btn-secondary"
                                        >
                                            <DateRangePicker
                                                showLeadingZeros={true}
                                                onChange={onDateChange}
                                                maxDate={new Date()}
                                                value={selectedDate}
                                                locale={CountryHelper.GetDateCulture(countryInfo.Culture)}
                                                clearIcon={null}
                                                calendarIcon={
                                                    <CalendarMonthOutlinedIcon
                                                        style={{
                                                            "font-size": "24px",
                                                            "align-self": "center",
                                                            color: "#666666",
                                                        }}
                                                    />
                                                }
                                            />
                                        </Stack>
                                    </Grid>
                                </Grid>
                                <Grid flex="1" spacing={2} className="form-sec p-0">

                                    <Box
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        sx={{ mb: 2 }}
                                    >
                                        <Tabs
                                            value={tabIndex}
                                            onChange={handleChange}
                                            aria-label="Order Status Tabs"
                                            className="font-size-14"
                                        >
                                            <Tab label={`Requested - ${requestedOrders.length}`} />
                                            <Tab label={`Partially Shipped - ${partiallyShippedOrders.length}`} />
                                            <Tab label={`Received - ${receivedOrders.length}`} />
                                            <Tab label={`Rejected - ${rejectedOrders.length}`} />
                                        </Tabs>

                                        <Button
                                            variant="contained"
                                            className="btn btn-primary"
                                            onClick={handleCreateOrder}
                                        >
                                            Create New Order
                                        </Button>
                                    </Box>

                                    {getFilteredOrders().map((order) => (
                                        <Card
                                            key={order.id}
                                            variant="outlined"
                                            sx={{
                                                mb: 4,
                                                p: 3,
                                                boxShadow: 4,
                                                borderRadius: 3,
                                                backgroundColor: "#ffffff",
                                                cursor: "pointer"
                                            }}
                                            style={{ cursor: "pointer;" }}
                                            className="font-size-14 card white-bg"
                                            onClick={() => handlenavigateOrderDetails(order)}
                                        >
                                            {/* Header: Order & Vendor */}
                                            <Grid container spacing={3}>
                                                {/* Vendor Info */}
                                                <Grid item xs={12} md={6}>
                                                    <Typography variant="h6" gutterBottom color="primary">🧾 Vendor Info</Typography>
                                                    <Typography><strong>Name:</strong> {order.vendorDetails.vendorName}</Typography>
                                                    <Typography><strong>Contact:</strong> {order.vendorDetails.vendorContact}</Typography>
                                                    <Typography><strong>Address:</strong>{getVendorFullAddress(order.vendorDetails)}</Typography>
                                                </Grid>

                                                {/* Order Info */}
                                                <Grid item xs={12} md={6}>
                                                    <Typography variant="h6" gutterBottom color="primary">📦 Order Info</Typography>
                                                    <Typography><strong>Order ID:</strong> {order.id}</Typography>
                                                    <Typography><strong>Created On:</strong> {moment(order.createdDT).format('L LT')}</Typography>
                                                    <Typography><strong>Status:</strong> {order.status}</Typography>
                                                    {!Utils.IsNullOrEmpty(order.comments) && (
                                                        <Typography color="error"><strong>Comment:</strong> {order.comments}</Typography>
                                                    )}
                                                </Grid>
                                            </Grid>

                                            {/* Divider */}
                                            <Divider sx={{ my: 2 }} />

                                            {/* Description & Total - Same Row */}
                                            <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: 2 }}>
                                                {/* Description */}
                                                <Grid item>
                                                    <Typography variant="body1" fontWeight={500}>
                                                        📝 <strong>Description:</strong> {order.orderDesc}
                                                    </Typography>
                                                </Grid>

                                                {/* Total Price */}
                                                <Grid item>
                                                    <Typography variant="h6" color="success.main">
                                                        💰 Total: {Utils.GetCurrency(order.totalPrice.toFixed(2), localSettings.country)}
                                                    </Typography>
                                                </Grid>
                                            </Grid>

                                        </Card>
                                    ))}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </Grid>
        </Container>
    )
}
export default BelowThreshold;